/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class AdjuntosService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * Obtiene la lista de adjuntos.
     * La programacion es mostradacon su paginacion.
     * @param empresaId Especifica la empresaid.
     * @param adjuntoId El id de un adjunto asociado a la empresa.
     * @param attachment Especifica el disposition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdAdjuntos(empresaId: string, adjuntoId: string, attachment?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getEmpresasByIdAdjuntos(empresaId: string, adjuntoId: string, attachment?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getEmpresasByIdAdjuntos(empresaId: string, adjuntoId: string, attachment?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getEmpresasByIdAdjuntos(empresaId: string, adjuntoId: string, attachment?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdAdjuntos.');
        }
        if (adjuntoId === null || adjuntoId === undefined) {
            throw new Error('Required parameter adjuntoId was null or undefined when calling getEmpresasByIdAdjuntos.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (attachment !== undefined && attachment !== null) {
            queryParameters = queryParameters.set('attachment', <any>attachment);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/adjuntos/${encodeURIComponent(String(adjuntoId))}`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
